import { AREA_PREFECTURES } from "../../constants/progressBanner"

export const getAreaPrefecture = (prefectureId: number): string | undefined => {
    for (const [area, prefectures] of Object.entries(AREA_PREFECTURES)) {
        if ((prefectures as readonly number[]).includes(prefectureId)) {
            return area
        }
    }
    return undefined
}
